import React from "react";
import NftVolumeBox from "./NftVolumeBox";

const NFTDetails = () => {
  return (
    <div className="col">
      <div className="row row-form">
        <NftVolumeBox
          title={"Today's Market Buyers"}
          image={"/img/img1.png"}
          value={"12,345"}
          time={"30 days data"}
          graph={"/img/line-graph.png"}
        />
        <NftVolumeBox
          title={"Today's Market Sellers"}
          image={"/img/img2.png"}
          value={"12,345"}
          time={"30 days data"}
          graph={"/img/line-graph.png"}
        />{" "}
        <NftVolumeBox
          title={"Today's Mints"}
          image={"/img/img1.png"}
          value={"12,345"}
          time={"30 days data"}
          graph={"/img/line-graph.png"}
        />{" "}
        <NftVolumeBox
          title={"Current Gas Fees"}
          image={"/img/img1.png"}
          value={"12,345"}
          time={"30 days data"}
          graph={"/img/line-graph.png"}
        />
      </div>
    </div>
  );
};

export default NFTDetails;
